import { Router } from '@angular/router';
import { EmailSettingsService } from './../email-settings.service';
import { DropDownConstantsFactory } from './../../../../base/shared/syncfusion/dropdown-constants-factory';
import { EmailAccountType, EmailProcessResultDTO } from './../../../../base/models/models.swagger.generated';
import { EnumTranslationService } from './../../../../base/services/enum-translation.service';
import { EmailSettingsFormType } from './../email-settings-form-type';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ToastService } from 'src/app/base/services/toast.service';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { YesNoGroupButtonComponent } from 'src/app/base/shared/yes-no-group-button/yes-no-group-button.component';
import { NgClass } from '@angular/common';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { PasswordVisibilityDirective } from 'src/app/directives/password-visibility.directive';
import { activationEmailTemplatesExpConfRoute, configurationTemplatesExpConfRoute, configurationsExpConfRoute, importConfigurationConfigurationRoute } from 'src/app/core/routing/route-names';
import { configurationEmailPageName } from 'src/app/core/routing/page-names';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';

@Component({
    selector: 'app-email-settings-edit-form',
    templateUrl: './email-settings-edit-form.component.html',
    styleUrls: ['./email-settings-edit-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, DropDownListAllModule, NgClass, TranslateModule, PasswordVisibilityDirective, TooltipModule]
})
export class EmailSettingsEditFormComponent implements OnInit, AfterViewChecked {
  @Input() public emailEditForm: FormGroup<EmailSettingsFormType>;
  @Input() public isEditModeEqualsEntry: boolean;

  public get formFields(): EmailSettingsFormType {
    return this.emailEditForm.controls;
  }

  public EmailAccountType = EmailAccountType;

  public enumDropdownSettings = DropDownConstantsFactory.createNumericEnumDropdownSettings();
  public accountTypes = this.enumTranslateService.translateNumericEnum(EmailAccountType, 'i18n.shared.email-account-type.');

  public emailTestForm: FormGroup<{ emailTestAddress: FormControl<string> }> = new FormGroup({ emailTestAddress: new FormControl<string>(null, [Validators.required, Validators.email]) });

  public isTestRunning = false;

  constructor(private enumTranslateService: EnumTranslationService,
    private cdr: ChangeDetectorRef,
    private emailSettingsService: EmailSettingsService,
    private toastService: ToastService,
    private router: Router) {
  }

  public ngOnInit() {
    if (this.isEditModeEqualsEntry) {
      const index = this.accountTypes.indexOf(this.accountTypes.find((obj) => obj.value.toString() == "2"), 0);
      if (index > -1) {
        this.accountTypes.splice(index, 1);
      }
    } else {
      const index = this.accountTypes.indexOf(this.accountTypes.find((obj) => obj.value.toString() == "1"), 0);
      if (index > -1) {
        this.accountTypes.splice(index, 1);
      }
    }

    // Receive only mails with attachments field
    if (this.isEditModeEqualsEntry) {
      this.formFields.receiveOnlyMailsWithAttachments.setValidators([Validators.required]);
      this.formFields.receiveOnlyMailsWithAttachments.updateValueAndValidity();
    } else {
      this.formFields.receiveOnlyMailsWithAttachments.clearValidators();
      this.formFields.receiveOnlyMailsWithAttachments.updateValueAndValidity();
    }

    //Office 365 fields
    if (this.formFields.accountType.value == EmailAccountType.Office365) {
      this.formFields.azureClientId.setValidators([Validators.required]);
      this.formFields.azureClientSecret.setValidators([Validators.required]);
      this.formFields.azureTenantId.setValidators([Validators.required]);
      this.formFields.password.setValidators([]);
      this.formFields.serverUrl.setValidators([]);
      this.formFields.userName.setValidators([]);
      this.formFields.useSSL.setValidators([]);
      this.formFields.port.setValidators([]);
    }
    else {
      this.formFields.userName.setValidators([Validators.required]);
      this.formFields.password.setValidators([Validators.required]);
      this.formFields.useSSL.setValidators([Validators.required]);
      this.formFields.port.setValidators([Validators.required]);
      this.formFields.serverUrl.setValidators([Validators.required]);
      this.formFields.azureClientId.setValidators([]);
      this.formFields.azureClientSecret.setValidators([]);
      this.formFields.azureTenantId.setValidators([]);
    }

    this.formFields.accountType.valueChanges.subscribe(v => {
      // if (v == EmailAccountType.IMAP) {
      //   this.formFields.serverUrl.setValidators([Validators.required]);
      //   this.formFields.userName.setValidators([Validators.required]);
      //   this.formFields.useSSL.setValidators([Validators.required]);
      //   this.formFields.port.setValidators([Validators.required]);
      //   this.formFields.password.setValidators([Validators.required]);
      //   this.formFields.serverUrl.updateValueAndValidity();
      //   this.formFields.userName.updateValueAndValidity();
      //   this.formFields.useSSL.updateValueAndValidity();
      //   this.formFields.port.updateValueAndValidity();
      //   this.formFields.password.updateValueAndValidity();
      // } else {
      //   this.formFields.serverUrl.setValue(null);
      //   this.formFields.userName.setValue(null);
      //   this.formFields.useSSL.setValue(null);
      //   this.formFields.port.setValue(null);
      //   this.formFields.serverUrl.setValidators([]);
      //   this.formFields.userName.setValidators([]);
      //   this.formFields.useSSL.setValidators([]);
      //   this.formFields.port.setValidators([]);
      //   this.formFields.password.setValidators([]);
      //   this.formFields.serverUrl.updateValueAndValidity();
      //   this.formFields.userName.updateValueAndValidity();
      //   this.formFields.useSSL.updateValueAndValidity();
      //   this.formFields.port.updateValueAndValidity();
      //   this.formFields.password.updateValueAndValidity();
      // }
      if (v == EmailAccountType.Office365) {
        this.formFields.azureClientId.setValidators([Validators.required]);
        this.formFields.azureClientSecret.setValidators([Validators.required]);
        this.formFields.azureTenantId.setValidators([Validators.required]);
        this.formFields.serverUrl.setValidators([]);
        this.formFields.userName.setValidators([]);
        this.formFields.useSSL.setValidators([]);
        this.formFields.port.setValidators([]);
        this.formFields.password.setValidators([]);
        this.formFields.serverUrl.updateValueAndValidity();
        this.formFields.userName.updateValueAndValidity();
        this.formFields.useSSL.updateValueAndValidity();
        this.formFields.port.updateValueAndValidity();
        this.formFields.password.updateValueAndValidity();
        this.formFields.azureClientId.updateValueAndValidity();
        this.formFields.azureClientSecret.updateValueAndValidity();
        this.formFields.azureTenantId.updateValueAndValidity();
      } else {
        this.formFields.azureClientId.setValue(null);
        this.formFields.azureClientSecret.setValue(null);
        this.formFields.azureTenantId.setValue(null);
        this.formFields.azureClientId.setValidators([]);
        this.formFields.azureClientSecret.setValidators([]);
        this.formFields.azureTenantId.setValidators([]);
        this.formFields.serverUrl.setValidators([Validators.required]);
        this.formFields.userName.setValidators([Validators.required]);
        this.formFields.useSSL.setValidators([Validators.required]);
        this.formFields.port.setValidators([Validators.required]);
        this.formFields.password.setValidators([Validators.required]);
        this.formFields.serverUrl.updateValueAndValidity();
        this.formFields.userName.updateValueAndValidity();
        this.formFields.useSSL.updateValueAndValidity();
        this.formFields.port.updateValueAndValidity();
        this.formFields.password.updateValueAndValidity();
        this.formFields.azureClientId.updateValueAndValidity();
        this.formFields.azureClientSecret.updateValueAndValidity();
        this.formFields.azureTenantId.updateValueAndValidity();
      }
    });
  }

  public ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  public sendTestEmail() {
    if (!this.emailTestForm.valid || this.isEditModeEqualsEntry) {
      return;
    }
    this.isTestRunning = true;
    this.emailSettingsService.sendTestEmail(this.emailEditForm, this.emailTestForm.value.emailTestAddress).subscribe({
      next: (result: EmailProcessResultDTO) => {
        this.isTestRunning = false;
        if (result.success) {
          this.toastService.showSuccess('i18n.domain.settings.email-settings.messages.email-test-success-title', result.errorMessage ?? 'i18n.domain.settings.email-settings.messages.test-email-success-message');
        } else {
          this.toastService.showError('i18n.domain.settings.email-settings.messages.email-test-failed-title', result.errorMessage);
        }
      }, error: () => {
        this.isTestRunning = false;
      }
    });
  }

  public onExportConfigLinkClicked(info: any) {
    this.onIdLinkClicked(info, configurationsExpConfRoute, configurationEmailPageName);
  }

  public onExportConfigTemplateLinkClicked(info: any) {
    this.onIdLinkClicked(info, configurationTemplatesExpConfRoute, configurationEmailPageName);
  }

  public onExportConfigActivationEmailTemplateLinkClicked(info: any) {
    this.onIdLinkClicked(info, activationEmailTemplatesExpConfRoute, null);
  }

  public onImportConfigLinkClicked(info: any) {
    this.onIdLinkClicked(info, importConfigurationConfigurationRoute, configurationEmailPageName);
  }

  public onLinkClicked(route: string) {
    this.router.navigate([route]);
  }

  public onIdLinkClicked(info: any, route: string, postIdPage?: string) {
    if (postIdPage == null) {
      this.router.navigate([route, info.id]);
    } else {
      this.router.navigate([route, info.id, postIdPage]);
    }
  }
}
